import { cn } from '@/lib/utils';

import Button from '@/components/atoms/Button';
import Card, { CardProps } from '@/components/atoms/Card';
import NextImage from '@/components/atoms/Image';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { applyToAllRTFVariants } from '@/components/atoms/RichTextField/utils';
import { Text } from '@/components/atoms/Text';
import { pullImagePropFromStrapiBlock } from '@/features/HomepageHero/helpers';
import { HomepageHeroCarouselContent } from '@/features/HomepageHero/HomepageHeroStrapi';
import React from 'react';
import HeroProgressBar from './HeroProgressBar';

/**
 * Memoized component because the Text component runs into a re-render loop because of the loader animation - and becomes unclickable.

 */
const MemoizedDescription = React.memo(
  ({ block }: { block: RichTextFieldStrapiProps }) => (
    <RichTextFieldStrapi
      classNames={applyToAllRTFVariants(cn('text-body-m pb-2 text-left'))}
      block={block}
    />
  )
);

function ProductCard({
  feature,
  isActive,
  CardProps,
  handleSelect,
}: {
  isActive: boolean;
  feature: HomepageHeroCarouselContent;
  CardProps?: Partial<CardProps>;
  handleSelect: () => void;
}) {
  return (
    <Button noStyles onClick={handleSelect}>
      <Card
        roudnessLevel='m'
        classNames={{
          root: cn(
            'border-none p-4 hover:dark:bg-gray-dark-900',
            !isActive &&
              'hover:dark:first:text-base-dark-white text-gray-dark-500',
            isActive ? 'dark:bg-gray-dark-900' : 'dark:bg-gray-dark-975'
          ),
        }}
        {...CardProps}
      >
        <div className='flex gap-3 mb-2 items-center'>
          {feature.cardIcon && (
            <NextImage
              height={24}
              width={24}
              fetchPriority='high'
              classNames={{ container: 'h-6 w-6' }}
              src={feature.cardIcon.image?.data?.attributes?.url ?? ''}
              alt={
                pullImagePropFromStrapiBlock(
                  feature.cardIcon,
                  'alternativeText'
                ) as string
              }
            />
          )}
          <Text
            classNames={{
              wrapper: cn('text-h5 font-serif '),
            }}
          >
            {feature.cardTitle}
          </Text>
        </div>

        <MemoizedDescription
          block={feature.cardDescription as RichTextFieldStrapiProps}
        />
        <HeroProgressBar isActive={isActive} />
      </Card>
    </Button>
  );
}

export default ProductCard;
